<template>
  <div class="container">
    <h5 class="title is-5">Configure Presence Detectors</h5>
    <div class="container has-text-left">
      <b-table
          :narrowed="true"
          :striped="true"
          :data="tableData"
      >
        <template slot-scope="props">
          <b-table-column label="Username" field="username">{{props.row.username}}</b-table-column>
          <b-table-column label="Presence detector devices">
            <app-user-presence-detector-devices :userId="props.row.id" :list="props.row.pds" :update="updateUserPds"/>
          </b-table-column>
        </template>
      </b-table>
      <hr/>
      <div>This is where you set which object is responsible for giving presence state about each user.</div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import BTable from "buefy/src/components/table/Table";
  import BTableColumn from "buefy/src/components/table/TableColumn";
  import UserPresenceDetectorDevices from "../components/configure/UserPresenceDetectorDevices";

  export default {
    components: {
      BTableColumn,
      BTable,
      appUserPresenceDetectorDevices: UserPresenceDetectorDevices
    },
    name: "screen-configure-presence-detectors",
    computed: {
      ...mapGetters('auth', ['userList']),
      tableData() {
        const ret = [];

        this.userList.forEach(user => {
          const { username, id, pds } = user;
          ret.push({
            id,
            username,
            pds
          });
        });

        return ret;
      }
    },
    methods: {
      ...mapActions('auth', ['updateUserPresenceDetectorDevices']),
      updateUserPds(payload) {
        this.updateUserPresenceDetectorDevices(payload);
      }
    },
    mounted() {
      /* eslint-disable */
      // console.log(this.userList);
    }
  }
</script>

<style scoped>

</style>